import Api from './api';

export const getSummary = async (startDate, endDate, organizationId, technicalTeamId, userId, originRequestId = 0) => {
  let data = [];
  await Api.get(`/dashboard/agentproductivity/summary?dateStart=${startDate}&dateEnd=${endDate}&organizationId=${organizationId}&technicalTeamId=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getByAgent = async (startDate, endDate, organizationId, technicalTeamId, userId, originRequestId = 0) => {
  let data = [];
  await Api.get(`/dashboard/agentproductivity/byagent?dateStart=${startDate}&dateEnd=${endDate}&organizationId=${organizationId}&technicalTeamId=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getByChannel = async (startDate, endDate, organizationId, technicalTeamId, userId, originRequestId = 0) => {
  let data = [];
  await Api.get(`/dashboard/agentproductivity/bychannel?dateStart=${startDate}&dateEnd=${endDate}&organizationId=${organizationId}&technicalTeamId=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getHourly = async (startDate, endDate, organizationId, technicalTeamId, userId, originRequestId = 0) => {
  let data = [];
  await Api.get(`/dashboard/agentproductivity/hourly?dateStart=${startDate}&dateEnd=${endDate}&organizationId=${organizationId}&technicalTeamId=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getFcr = async (startDate, endDate, organizationId, technicalTeamId, userId, originRequestId = 0) => {
  let data = [];
  await Api.get(`/dashboard/agentproductivity/fcr?dateStart=${startDate}&dateEnd=${endDate}&organizationId=${organizationId}&technicalTeamId=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};
